import { Component, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import * as moment from 'moment';
import { ResearchPortalBdService } from '../../../../services/research-portal-bd.service';
import { MaterialPageGrid } from '../../../../utils/material-page-grid';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-historical-data',
  templateUrl: './historical-data.component.html',
  styleUrls: ['./historical-data.component.scss'],
})
export class HistoricalDataComponent implements OnInit, AfterViewInit {
  selectedCompany;
  resultsPageGrid: MaterialPageGrid<any>;
  gridInProgress: boolean;
  gridColumns = [];

  setFromDateAsMinDate = moment().subtract(1, 'months').toDate();
  columns = [
    { id: 2, colOptional: true, label: 'Open (BDT)', selected: true, field: 'openPrice', type: 'money', align: 'text-end' },
    { id: 3, colOptional: true, label: 'High (BDT)', selected: true, field: 'highPrice', type: 'money', align: 'text-end' },
    { id: 4, colOptional: true, label: 'Low (BDT)', selected: true, field: 'lowPrice', type: 'money', align: 'text-end' },
    { id: 5, colOptional: true, label: 'Close (BDT)', selected: true, field: 'todayClosePrice', type: 'money', align: 'text-end' },
    { id: 8, colOptional: true, label: 'Volume', selected: true, field: 'totalVolume', type: 'number', align: 'text-end' },
    { id: 9, colOptional: true, label: 'Total Value', selected: true, field: 'totalValue', type: 'money', align: 'text-end' },
    { id: 10, colOptional: true, label: 'No. of trades', selected: true, field: 'totalTrades', type: 'number', align: 'text-end' },
  ];

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;

  constructor(private cdRef: ChangeDetectorRef, private researchPortalService: ResearchPortalBdService, private fb: FormBuilder) {}

  ngOnInit(): void {
    this.researchPortalService.emitChange$.subscribe(async (data) => {
      if (data) {
        this.selectedCompany = data;
        await this.initialize();
        // inside initialize()

        setTimeout(() => {
          if (this.paginator) {
            console.log('Attaching paginator');
            this.resultsPageGrid.attachPaginator(this.paginator);
          } else {
            console.warn('Paginator not available at this time');
          }
        }, 1500);
      }
    });
  }

  async initialize() {
    this.gridColumns = this.columns.filter((item) => item.selected === true);
    const tableHd = ['date', ...this.gridColumns.map((c) => c.field)];
    this.resultsPageGrid = new MaterialPageGrid(this.fb)
      .setFilters({
        dateFrom: [moment().subtract(1, 'months').toDate(), [], []],
        dateTo: [moment().toDate(), []],
      })
      .setSource(async (query) => {
        let data = [];
        let count = 0;
        try {
          // alert('Fetching data');
          // Fetch historical data based on date range
          let from = moment(query.filterValues.dateFrom).startOf('day').format('YYYY-MM-DD');
          let to = moment(query.filterValues.dateTo).endOf('day').format('YYYY-MM-DD');
          this.gridInProgress = true;
          data = await this.researchPortalService.getHistoricalData(from, to, this.selectedCompany.companyName);
          count = data.length;
          this.cdRef.detectChanges();
        } catch (error) {
          count = 0;
          this.cdRef.detectChanges();
        }
        this.gridInProgress = false;
        return { data: data.slice(query.pageIndex * query.pageSize, (query.pageIndex + 1) * query.pageSize), total: count };
      })
      .setTableColumns(tableHd);
    this.resultsPageGrid.filtersForm.get('dateFrom').valueChanges.subscribe((value) => {
      this.setFromDateAsMinDate = moment(value).toDate();
      let toDate = this.resultsPageGrid.filtersForm.get('dateTo').value;
      if (!moment(toDate).isAfter(this.setFromDateAsMinDate)) {
        this.resultsPageGrid.filtersForm.get('dateTo').setValue(this.setFromDateAsMinDate);
      }
    });
    setTimeout(() => {
      if (this.resultsPageGrid) {
        this.resultsPageGrid.attachSort(this.sort);
      }
    }, 500);
    this.cdRef.detectChanges();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.resultsPageGrid && this.sort) {
        this.resultsPageGrid.attachSort(this.sort);
      }
    }, 0);
  }

  getColumn(col) {
    return col === 'date' ? 'Date' : this.gridColumns?.find((c) => c.field === col)?.label || col;
  }
  formatColumn(col, type): boolean {
    return this.gridColumns?.find((c) => c.field === col)?.type === type;
  }

  emitSelectedColumns = (e) => {
    this.gridColumns = e;
    const displayedColumns = ['date', ...this.gridColumns.map((c) => c.field)];
    if (this.resultsPageGrid) {
      this.resultsPageGrid.setTableColumns(displayedColumns);
      // Re-attach paginator and sort after columns change
      setTimeout(() => {
        if (this.paginator && this.sort) {
          // this.resultsPageGrid.attachPaginator(this.paginator);
          this.resultsPageGrid.attachSort(this.sort);
        }
      });
    }
  };
}
